import React, { useState, useMemo, useEffect } from 'react';
import ReactPaginate from "react-paginate";
import CopyToClipboard from 'react-copy-to-clipboard'
import { useSelector } from 'react-redux';
import { useTable, useSortBy, usePagination } from "react-table";
import { MdContentCopy } from 'react-icons/md'
import { BsArrowDown, BsArrowUp, BsArrowDownUp } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi'
import { RiArrowDownSLine, RiArrowRightSLine, RiArrowUpSLine } from 'react-icons/ri';
import { Collapse, Row, Col, Input, Label, Button, Table } from 'reactstrap'

import { COLUMNS } from "./constants/columns";

import * as controller from '../../controllers/inconsistenciasProducaoController'
import { notifySuccess } from '../../components/message/message';

export default function Produto(){
    const { tiposOperacao, tab } = useSelector(state => state.inconsistenciaProducao);
    return(
        <div style={{width: '93%', marginLeft: '25px'}}>
            {tiposOperacao.map((e,i)=>{
                return(
                    <CollapsedCard inconsistencia={e} index={i} tab={tab}/>
                )
            })}
        </div>
    )
}

function CollapsedCard({inconsistencia, index, tab}){
    const { tabs } = useSelector(state => state.inconsistenciaProducao);
    
    const columns = useMemo(() => COLUMNS, []);
    const data = inconsistencia.propostas;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        gotoPage,
        state,
        setPageSize,
    } = useTable({
        columns,
        data
    },
        useSortBy,
        usePagination);

    const { pageSize } = state;
    const [rows, setRows] = useState(0);
    const [initialPage, setInitialPage] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);

    useEffect(() => {
        setRows(page.length);
    }, [page])

    useEffect(() => {
        setPageSize(5);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePageClick = (e) => {
        const pageSelected = e.selected;
        setInitialPage(false);
        setSelectedPage(pageSelected);
        gotoPage(pageSelected);
    }

    const pageCount = Math.ceil(data.length / pageSize);

    const [isCardOpen, setIsCardOpen] = useState(false)

    function handleCorrigirInconsistencia(){
        const baseURL = window.location.origin
        window.open(`${baseURL}/operacaoinstituicao?isRedirect=true`)
    }

    async function handleRefresh(){
        await controller.correcaoInconsistencia(inconsistencia, tab)
        await controller.getQuantidade(tabs)
    }

    return(
        <div style={{borderTop: '1px solid #CCCFDE', marginBottom: '30px'}}>
            <div style={{display: 'flex', marginTop: '30px'}} >
                <div style={{width: '95%'}}>
                    <Row>
                        <Col md={3}>
                            <Label style={{fontWeight: 'bold'}}>Descrição da operação instituição</Label>
                            <div style={{display: 'flex', border: '1px solid var(--color-laranja)', borderRadius: '0.25rem', padding: '8px 0 8px 10px', background: '#E9ECEF'}}>
                                <p style={{width: '95%', margin: '0'}}>
                                   {inconsistencia.operacaoInstituicao}
                                </p>
                                <CopyToClipboard text={inconsistencia.operacaoInstituicao} onCopy={()=> notifySuccess('Copiado!')}>
                                    <button style={{background: 'transparent', border: 'none'}}> <MdContentCopy style={{color: 'var(--color-verde-claro)', marginRight: '10px'}}/></button>
                                </CopyToClipboard>
                            </div>
                        </Col>
                        <Col md={3}>
                            <Label style={{fontWeight: 'bold'}}>Instituição Financeira</Label>
                            <Input
                                type="text"
                                placeholder="Busque um favorecido..."
                                value={inconsistencia.instituicao}
                                disabled
                            />
                        </Col>
                        <Col md={3}>
                            <Label style={{fontWeight: 'bold'}}>Nome do arquivo importado</Label>
                            <Input
                                type="text"
                                placeholder="Busque um favorecido..."
                                value={inconsistencia.nomeArquivoImportado}
                                disabled
                            />
                        </Col>
                    </Row>
                </div>
                <div style={{display: 'flex'}}>
                    <FiRefreshCcw 
                    style={{paddingTop: '5px', fontSize: '20px', cursor: 'pointer'}} 
                    onClick={() => handleRefresh()}/>
                    {isCardOpen ? 
                        <RiArrowUpSLine 
                        style={{fontSize: '25px', cursor: 'pointer'}} 
                        onClick={()=> setIsCardOpen(!isCardOpen)}/> 
                    : 
                        <RiArrowDownSLine 
                        style={{fontSize: '25px', cursor: 'pointer'}}
                        onClick={()=> setIsCardOpen(!isCardOpen)}/>}
                </div>
            </div>
            <Collapse isOpen={isCardOpen} style={{paddingLeft: '5px'}}>
                <Row style={{marginTop: '15px'}}>
                    <div style={{width: '100%'}}>
                        <Button 
                        className='purpleButton' 
                        style={{width: '216px',margin: '12px 0 7px 80%'}}
                        onClick={()=> handleCorrigirInconsistencia()}>
                            <RiArrowRightSLine style={{fontSize: '20px', paddingBottom: '3px'}}/> 
                            Corrigir Inconsistência
                        </Button>
                        <span style={{marginLeft: '80%', fontSize: '12px', color: 'var(--color-cinza-medio)'}}> 
                            Você será redirecionado para outra tela
                        </span>
                    </div>
                </Row>
                    <Table striped {...getTableProps()} style={{marginTop: '20px'}}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th>
                                            {column.render("Header")}
                                            <span className="float-right">
                                                {column.isSorted ?
                                                    (column.isSortedDesc ?
                                                        <BsArrowDown
                                                            {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                        />
                                                        :
                                                        <BsArrowUp
                                                            id="OrdenarAsc"
                                                            {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                        />)
                                                    :
                                                    <BsArrowDownUp
                                                        id="Ordenar"
                                                        {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                    />}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row)
                                return (
                                    <tr className="text-center" {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (<td {...cell.getCellProps()}>{cell.render("Cell")}</td>)
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                        <Row className="pt-4">
                            <Col>
                                <span style={{ color: "var(--color-cinza-medio)" }}>Mostrando {rows} de {data.length}</span>
                            </Col>
                            <Col md={8}>
                                <Row className="float-right">
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        initialPage={0}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={initialPage ? 0 : selectedPage}
                                    />
                                </Row>
                            </Col>
                        </Row>
            </Collapse>
        </div>
    )
}